const data = {
  id: "voting_rights",
  title: "The Ballot & Your Access",
  intro: "Voting is your civic duty. It's also apparently a full-day errand. Why does participating in democracy keep ending up at the bottom of your to-do list — and who keeps putting it there?",
  tabs: [
    {
      id: "overview",
      label: "Overview",
      stats: [],
      issues: [],
      trail: []
    },
    {
      id: "suppression",
      label: "Suppression",
      stats: [],
      issues: [],
      trail: []
    },
    {
      id: "registration",
      label: "Registration",
      stats: [],
      issues: [],
      trail: []
    },
    {
      id: "polling_locations",
      label: "Polling Locations",
      stats: [],
      issues: [],
      trail: []
    },
    {
      id: "my_representative",
      label: "My Representative",
      stats: [],
      issues: [],
      trail: []
    }
  ]
};
export default data;
